import Axios, { AxiosInstance, Method } from 'axios'
import { RequestError } from 'src/common-services'
import qs from 'qs'
import { CompanyPayload } from 'src/common-services/clients/vendors/companies'

const AUTH_TOKEN = '0to3CFypr/wVDxW5ATQbHjX/jZ4MKru1ndkFBGEthmY='

export type BrandLink = {
  name: string
  url: string
}

export type BrandImgFormat = {
  src: string
  background: string | null
  format: 'png' | 'svg' | 'jpeg'
  height: number
  width: number
  size: number
}

export type BrandLogo = {
  type: 'logo' | 'icon' | 'symbol'
  formats: BrandImgFormat[]
}

export type BrandColor = {
  hex: string
  type: 'accent' | 'dark' | 'light' | 'brand'
  brightness: number
}

export type BrandFont = {
  name: string
  type: 'title' | 'body'
  origin: 'google' | 'custom' | 'system' | null
  originId: string | null
}

export type BrandImage = {
  type: 'banner' | null
  format: BrandImgFormat[]
}

export type Brand = {
  name: string
  domain: string
  claimed: boolean
  description: string
  links: BrandLink[]
  logos: BrandLogo[]
  colors: BrandColor[]
  fonts: BrandFont[]
  images: BrandImage[]
}

export type GetBrandParams = {
  domain: string
}

export class BrandsClient {
  private readonly axios: AxiosInstance
  protected readonly baseUrl: string = 'https://api.brandfetch.io/v2/'
  protected readonly timeout = 1000

  constructor() {
    this.axios = Axios.create({
      baseURL: this.baseUrl,
      timeout: this.timeout,
      paramsSerializer(params) {
        return qs.stringify(params)
      },
    })
  }

  protected async post<T>(url: string, data: any): Promise<T> {
    return this.call<T>(url, 'POST', { data })
  }

  protected async call<T>(
    url: string,
    method: Method,
    request?: { params?: any; data?: any; responseType?: any }
  ): Promise<T> {
    try {
      const req = {
        method,
        params: request?.params,
        data: request?.data,
        responseType: request?.responseType,
        url,
        headers: {
          Authorization: `Bearer ${AUTH_TOKEN}`,
        },
      }
      const response = await this.axios.request(req)
      return response.data as T
    } catch (error: any) {
      const message = error.response?.data?.error || error.message
      throw new RequestError(message, error.response?.status, error)
    }
  }

  public async getBrand(request: GetBrandParams): Promise<Brand> {
    return this.call<Brand>(`/brands/${request.domain}`, 'GET')
  }

  public toCompany(brand: Brand): CompanyPayload {
    return {
      name: brand.name,
      domain: brand.domain,
      logo:
        brand.logos.find((i) => i.type === 'icon')?.formats[0].src ||
        brand.logos.find((i) => i.type === 'logo')?.formats[0].src ||
        '',
    }
  }
}
